<template>
  <div class="insights-smart-notifications-widget">
    <div class="widget-title mb-20">
      Smart Notifications
      <i
        v-if="isReady"
        v-tooltip
        class="hi hi-info-filled ml-5"
        :title="tooltipText"
      />
    </div>
    <InsightsNoData
      v-if="!hasSmartNotifications && !loadingWidgets.smart_notifications"
      type="no_data"
    >
      <template
        v-if="!hasActiveSmartNotifications"
        #title
      >You don’t have any Smart Notifications</template>
      <template
        v-else
        #title
      >{{ '' }}</template>

      <template #description>
        No one has triggered your notifications in the selected time period
      </template>
      <template #button>
        <AppButton
          class="mt-20"
          type="primary"
          @click="openSmartNotificationsPage"
        >
          Create a Smart Notification
        </AppButton>
      </template>
    </InsightsNoData>
    <AppCarousel
      v-if="loadingWidgets.smart_notifications"
      key="sn-loading"
    >
      <InsightsPerformanceHighlightsCardLoading
        v-for="i in 3"
        :key="i"
      />
    </AppCarousel>
    <AppCarousel v-if="isReady && hasSmartNotifications && !loadingWidgets.smart_notifications">
      <InsightsSmartNotificationsCard
        v-for="notification in smartNotificationList"
        :key="`sn-${notification.id}`"
        :notification="notification"
        @open-dialog="openDialog"
      />
    </AppCarousel>
    <InsightsSmartNotificationsDialog
      v-if="showDialog"
      :show="showDialog"
      :notification="selectedNotification"
      @close="closeDialog"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapState } from 'vuex';
import { Insights, InsightsFilters, InsightsTracking } from '~/mixins';
import AppCarousel from '~/components/AppCarousel.vue';
import InsightsSmartNotificationsCard from '~/components/insights/InsightsSmartNotificationsCard.vue';
import InsightsPerformanceHighlightsCardLoading from '~/components/insights/InsightsPerformanceHighlightsCardLoading.vue';

import { get } from 'lodash-es';

export default {
  name: 'InsightsSmartNotificationsWidget',
  components: {
    AppCarousel,
    InsightsSmartNotificationsCard,
    InsightsNoData: defineAsyncComponent(() => import('~/components/insights/InsightsNoData.vue')),
    InsightsSmartNotificationsDialog: defineAsyncComponent(() => import('~/components/insights/InsightsSmartNotificationsDialog.vue')),
    InsightsPerformanceHighlightsCardLoading,
  },
  mixins: [Insights, InsightsFilters, InsightsTracking],
  data() {
    return {
      // The shared Insights mixin's `isReady` reads `this.widgetKey` (this widget's data lives under
      // `state.widgets.smart_notifications`); without it the getter read undefined and Vue warned.
      widgetKey: 'smart_notifications',
      tooltipText:
        'In addition to Email and Slack delivery, Smart Notifications can be delivered here ' +
        'within the Highlights tab of Insights',
      showDialog: false,
      selectedNotification: {},
    };
  },
  computed: {
    ...mapState({
      smart_notification_settings_url: (state) => state.smart_notification_settings_url,
      smartNotifications: (state) => get(state.widgets, 'smart_notifications', []),
      activeSmartNotifications: (state) => state.num_active_smart_notifs,
    }),
    smartNotificationList() {
      return this.smartNotifications && this.smartNotifications.filter((notification) => notification?.matches.length);
    },
    hasSmartNotifications() {
      return this.smartNotificationList.length;
    },
    hasActiveSmartNotifications() {
      return this.activeSmartNotifications > 0;
    },
  },
  methods: {
    openDialog(notification) {
      if (!this.showDialog) {
        this.selectedNotification = notification;
        this.showDialog = true;
      }
    },
    closeDialog() {
      this.showDialog = false;
    },
    openSmartNotificationsPage() {
      window.location.href = this.smart_notification_settings_url;
    },
  },
};
</script>
